import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useTheme,
} from '@mui/material';
import {
  Language as LanguageIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const LanguageToggle: React.FC = () => {
  const { i18n, t } = useTranslation();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
    handleClose();
  };

  const getCurrentLanguageLabel = () => {
    switch (i18n.language) {
      case 'en':
        return 'EN';
      case 'es':
        return 'ES';
      default:
        return 'ES';
    }
  };

  const languages = [
    {
      code: 'es',
      name: t('language.spanish'),
      flag: '🇪🇸',
    },
    {
      code: 'en',
      name: t('language.english'),
      flag: '🇺🇸',
    },
  ];

  return (
    <>
      <Tooltip title="Cambiar idioma / Change language">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{
            width: 40,
            height: 40,
            border: 1,
            borderColor: theme.palette.divider,
            borderRadius: 1,
            backgroundColor: theme.palette.background.paper,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          <LanguageIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
      
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '& .MuiMenu-paper': {
            borderRadius: 2,
            minWidth: 150,
            border: 1,
            borderColor: theme.palette.divider,
          },
        }}
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={i18n.language === language.code}
            sx={{
              gap: 1,
              '&.Mui-selected': {
                backgroundColor: theme.palette.primary.light + '20',
                '&:hover': {
                  backgroundColor: theme.palette.primary.light + '30',
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 'auto', fontSize: '1.2rem' }}>
              {language.flag}
            </ListItemIcon>
            <ListItemText 
              primary={language.name}
              primaryTypographyProps={{
                fontSize: '0.9rem',
                fontWeight: i18n.language === language.code ? 600 : 400,
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageToggle; 